.i2{border-radius:0.375rem;}